import 'plyr/dist/plyr.css';

import React from 'react';

export * from './utils';
const VideoPlayer = React.lazy(() => import(/* webpackChunkName: "lygo-react-plyr" */ './Video'));

export const AudioPlayer = React.lazy(
  () => import(/* webpackChunkName: "lygo-react-audio-plyr" */ './Audio'),
);

export default VideoPlayer;
